<!--下拉单选组件-->
<template>
	<div class="selectionBody" @mouseenter="showUl = true" @mouseleave="showUl = false">
		<p :style="getTitleBackGroud">{{nowTitle}}</p>
		<ul v-show="showUl">
			<li v-for="(item,index) in dataList" :key='index' @click.stop="nowIndex = index"><img :src="getImg(index)" /><span>{{item[nameKey]}}</span></li>
		</ul>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: {
			nameKey: {
				type: String,
				default: 'name'
			},
			dataList: {
				type: Array,
				default: () => {
					return []
				}
			},
			autoCheck: {
				type: Number,
				default: 0
			},
		},
		data() {
			return {
				nowIndex: undefined,
				showUl: false,
				titleId: randomPkid(),
			}
		},
		created() {},
		mounted() {
			this.nowIndex = this.autoCheck
		},
		destroyed() {},
		computed: {
			nowItem() {
				//当前选中项
				return this.dataList[this.nowIndex]
			},
			nowTitle() {
				return getValueIfNoNull(getValueIfNoNull(this.nowItem, {})[this.nameKey], "未选中")
			},
			getTitleBackGroud() {
				if (!this.showUl) {
					return resourcesStore.getters.getBackgroudImageStyle('multipleSelection/newarrowDown.png')
				}
				return resourcesStore.getters.getBackgroudImageStyle('multipleSelection/newarrowUp.png')
			},
		},
		watch: {
			dataList(nv, ov) {
				//数据源改变时充值
				this.nowIndex = this.autoCheck
			},
			nowItem(nv, ov) {
				if (nv != undefined) {
					this.$emit('checkItem', nv)
				}
			}
		},
		methods: {
			getImg(index) {
				if (index == this.nowIndex) {
					return resourcesStore.getters.getResourcesByName("checkBox/checked.png")
				}
				return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
			}
		}
	}
</script>

<style scoped>
	.selectionBody {
		width: 1.5rem;
		background: white;
		position: relative;
		color: black;
		cursor: pointer;
	}

	.selectionBody>p {
		padding: .05rem;
		white-space: nowrap;
	}

	.selectionBody>ul {
		position: absolute;
		background: white;
		width: 100%;
		border-radius: 0 0 .1rem .1rem;
		border: #CECECE solid 1px;
		z-index: 100;
	}

	.selectionBody>ul>li {
		padding: 5px 2px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		border-bottom: #CECECE dashed 1px;
		cursor: pointer;
	}

	.selectionBody>ul>li>img {
		width: .2rem;
		height: .2rem;
		margin-right: .1rem;
	}
</style>
